import React, { useMemo } from "react";
import {SalesSummaryPackage} from "./SalesSummaryPackage";
import {SalesPackageOption} from "../SalesPackageOption";
import {VehicleGroup} from "../../../model/vehicle";
import {strings} from "../../../strings/strings";
import {sumInsuredFormat} from "../../../utils/format";
import {isSmartDrive} from "../../../utils/quotation";
import useSwitchToNewContent from "../../../utils/hooks/useSwitchToNewContent";

interface CASCOSummaryPackage {
    vehicleGroup: VehicleGroup;
    premium: number;
    deductible: number;
    mtplContract: number;
    vtplAdditionalCoverage: number;
    cascoAdditionalCoverage: number;
    packageName: string;
    tarrificationProgram: string;
}

export const CASCOSummaryPackage = (props: CASCOSummaryPackage) => {
    const {
        mtplContract,
        deductible,
        vtplAdditionalCoverage,
        cascoAdditionalCoverage,
        vehicleGroup,
        premium,
        packageName,
        tarrificationProgram
    } = props;
    const showNewContent = useSwitchToNewContent()


    const initOptions = () => {
        const options = [
            <SalesPackageOption name={strings.packageOptionMtplName}
                                tooltipPlacement={"left"}
                                tooltip={<ul>
                                   <li>{showNewContent ? strings.packageOptionMtplText1in2025 : strings.packageOptionMtplText1}</li>
                                   <li>{showNewContent ? strings.packageOptionMtplText2in2025 : strings.packageOptionMtplText2}</li>
                                </ul>}
                                key={"casco_option_1"}
                                covered={true}
                                price={mtplContract}/>,
            <SalesPackageOption name={`${strings.franchise} ${sumInsuredFormat(deductible)} ${strings.currencyUAH}`}
                                covered={true}
                                key={"casco_option_2"}
                                tooltipPlacement={"left"}
                                tooltip={<div><span
                                className={"accent"}>{strings.franchise2}</span>{strings.franchiseDescription}</div>}
                                />,
        ];

        if (vtplAdditionalCoverage) {
            options.push(<SalesPackageOption name={strings.packageOptionVtplName}
                                             covered={true}
                                             price={vtplAdditionalCoverage}/>);
        }

        options.push(<SalesPackageOption name={
            isSmartDrive(tarrificationProgram) ?
                strings.packageOptionCascoNameSmartDrive
                :
                strings.packageOptionCascoName
        }
                                         covered={true}
                                         price={cascoAdditionalCoverage}/>);

        return options;
    };

    const packageDisplayName = useMemo(() => {
        if (isSmartDrive(tarrificationProgram)) return strings.smartDrive.packageBasePlusName;
        if (packageName) return `${strings.scenarioHeaderName} "${packageName}"`;
        return strings.packageCascoName;
    }, [strings, tarrificationProgram, packageName]);

    return (
        <SalesSummaryPackage
            vehicleGroup={vehicleGroup}
            name={packageDisplayName}
            premium={premium}
            tarrificationProgram={tarrificationProgram}
            options={initOptions()}/>
    )
};
